module.exports = __webpack_public_path__ + "static/media/life-redemption-banner-mobile.b747b993.jpg";